import { api } from 'utility';
import {
  getPermissionUrl,
  getConfirmPermissonByGrantUrl,
  getRevokeConfirmGrantPermissionUrl,
  getDGrandetPersmiFromOwnerUrl
  
} from 'URLs';
export function getPermission(params) {
  return api.get(getPermissionUrl(), { params }).then((res) => res.data);
}

export function confirmGrantPermission(item) {
  return api.post(getConfirmPermissonByGrantUrl(item)).then((res) => res.data);
}

export function revokeGrantPermission(item) {
  return api.post(getRevokeConfirmGrantPermissionUrl(item)).then((res) => res.data);
}

export function deleteGrantPermission(item) {
  return api.delete(getDGrandetPersmiFromOwnerUrl(item)).then((res) => res.data);
}

export default {
  getPermission,
  confirmGrantPermission,
  revokeGrantPermission,
  deleteGrantPermission,
};
